import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../services";
import toast from "react-hot-toast";

const initialState = {
    studentIncidentReport: null,
    sectionIncidentReports: [],
    loading: false,
    error: null,
};

// Fetch incident report for a single student
export const fetchStudentIncidentReport = createAsyncThunk(
    "studentIncidentReport/fetchStudentIncidentReport",
    async (studentId, { rejectWithValue }) => {
        try {
            const response = await getRequest(`/api/Reports/StudentIncidentReport?studentId=${studentId}`);
            console.log("Student Incident Report API Response:", response.data);
            if (response.status !== 200) throw new Error("Failed to fetch student incident report");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Fetch incident reports for a section (if API becomes available)
export const fetchSectionIncidentReports = createAsyncThunk(
    "studentIncidentReport/fetchSectionIncidentReports",
    async (sectionData, { rejectWithValue }) => {
        try {
            const sectionId = sectionData.id;
            
            if (!sectionId) {
                return rejectWithValue("Section ID is required");
            }
            
            // Note: Update this endpoint when the section incident report API is available
            // For now, this might return 404 or we can fetch all students in section individually
            const response = await getRequest(`/api/Reports/SectionIncidentReport?sectionId=${sectionId}`);
            
            if (response.status !== 200) {
                throw new Error("Failed to fetch section incident reports");
            }
            
            console.log("Section Incident Reports API Response:", response.data);
            return response.data;
            
        } catch (error) {
            console.error("Error in fetchSectionIncidentReports:", error);
            return rejectWithValue(error.message || "Failed to fetch section incident reports");
        }
    }
);

const studentIncidentReportSlice = createSlice({
    name: "studentIncidentReport",
    initialState,
    reducers: {
        clearStudentIncidentReport: (state) => {
            state.studentIncidentReport = null;
            state.error = null;
        },
        clearSectionIncidentReports: (state) => {
            state.sectionIncidentReports = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStudentIncidentReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStudentIncidentReport.fulfilled, (state, action) => {
                state.loading = false;
                state.studentIncidentReport = action.payload;
            })
            .addCase(fetchStudentIncidentReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to fetch student incident report");
            })
            .addCase(fetchSectionIncidentReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSectionIncidentReports.fulfilled, (state, action) => {
                state.loading = false;
                state.sectionIncidentReports = action.payload;
            })
            .addCase(fetchSectionIncidentReports.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to fetch section incident reports");
            });
    },
});

export const { clearStudentIncidentReport, clearSectionIncidentReports } = studentIncidentReportSlice.actions;
export default studentIncidentReportSlice.reducer;

